module.exports = __webpack_public_path__ + "media/src/images/page02_sub_001_zu02-4822d98e3a99a6c78b3bb610510f529c.gif";